import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SowChangeVerifyTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_VERIFY),
  attemptType: z.literal("VERIFIED"),
});
